import React, { CSSProperties, useEffect, useState } from 'react';
import { useTranslate } from '../../i18n/useTranslationModules';
import { sortQuestionsOptions } from '../../types/working-model';
import FilterDropdown from '../live-event/modules/agenda/session-filter-dropdown';
import { SelectOption } from './select/select';
import { useTypedSelector } from '../../store/reducers/use-typed-selector';


export const getQuestionFilterOptions = (t: (t: string) => string) => [
	{
		label: t('Newest'),
		value: sortQuestionsOptions.newest
	},
	{
		label: t('Oldest'),
		value: sortQuestionsOptions.oldest
	},
	{
		label: t('Most Popular'),
		value: sortQuestionsOptions.most_likes
	},
];

interface IQuestionsFilterProps {
	value: sortQuestionsOptions;
	handleChange: (option: SelectOption) => void;
	template: string;
	displayOnly?: boolean;
	style?: CSSProperties
}

const QuestionsFilter: React.FC<IQuestionsFilterProps> = ({ value, handleChange, template, displayOnly = false, style }) => {
	const { t } = useTranslate("session");
	const translationUpdates = useTypedSelector(event => event.LiveEventReducer.translationUpdates);
	const [translatedTitleQuestionFilter, setTranslatedTitleQuestionFilter] = useState("");
	const questionFilterOptions = getQuestionFilterOptions(t);

	const translateQuestionFilterTitle = (title: string, t: (t: string) => string) => {
		switch (title) {
			case "newest":
				return t("Newest");
			case "oldest":
				return t('Oldest');
			case "most_likes":
				return t('Most Popular');
			default:
				break;
		}
	};

	useEffect(() => {
		const translated = translateQuestionFilterTitle(sortQuestionsOptions[value], t);
		if (translated) {
			setTranslatedTitleQuestionFilter(translated);
		}
	}, [t, translationUpdates, value]);


	return (
		<FilterDropdown
			options={questionFilterOptions}
			onChange={handleChange}
			template={template}
			value={value}
			className="questions-sort-filter"
			displayOnly={displayOnly}
			translatedTitleQuestionFilter={translatedTitleQuestionFilter}
			style={style}
		/>
	);
};

export default QuestionsFilter;
